import React, { lazy } from "react";
import Login from "../Pages/Login/Login";

const AuthRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
];

export default AuthRoutes;
